import useReviewsPhotosStore from '~/modules/reviews/stores/useReviewsPhotosStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

const useReviewsPhotos = () => passStoreThroughComposableFactory(useReviewsPhotosStore());

export default useReviewsPhotos;
